module.exports = __webpack_public_path__ + "img/banner3.e8e74e94.jpg";